/**
 * Uniapi configuration
 */
export const apiCfg = {
  timeoutUA: 45000,
  timeoutCA: 30000,
  retries: 0
};

/**
 * App values coming from env.
 */
export const app = {
  country: process.env.COUNTRY,
  version: process.env.VERSION,
  versionExtended: process.env.VERSION_EXT
};

/**
 * Type of the stream VOD or Live.
 */
export const streamType = {
  vod: 'vod',
  live: 'live',
  recording: 'recording'
};

/**
 * Oauth configuration.
 */
export const oauth = {
  method: 'HMAC-SHA1',
  version: '1.0'
};

/**
 * Chromecast message namespace
 */
export const messageNamespace = 'urn:x-cast:com.telefonica.video.cast';

/**
 * Messages exchanged between sender and receiver.
 */
export const messages = {
  // New GVP configuration received.
  gvpConfig: 'gvpConfig',
  // Chromecast is ready to cast because user is logged in.
  readyToCast: 'readyToCast',
  // Advanced TV
  seekLive: 'seekLive',
  launchStartOver: 'launchStartOver',
  launchLive: 'launchLive',
  streamProgress: 'streamProgress',
  // Devices requested it in order to stop listening "streamProgress"
  // after they perform a seek until they receive "seekSuccess".
  // CC sends its timestamps always properly. It seems to be a race condition on devices.
  // https://jira.tid.es/browse/GVPARG-639
  seekSuccess: 'seekSuccess',
  // Parental control live
  requestPinSuccess: 'requestPinSuccess',
  requestPin: 'requestPin',
  expiredRequestPin: 'expiredRequestPin',
  // Audios annd subtitles
  subtitles: 'subtitles',
  audios: 'audios',
  enableSubtitle: 'enableSubtitle',
  disableSubtitle: 'disableSubtitle',
  changeAudio: 'changeAudio',
  // Miniguide
  showMiniguide: 'showMiniguide',
  // Error
  error: 'error'
};

/**
 * Code for disabled
 */
export const OFF = 'zxx';

/**
 * Integration level for Youbora
 */
export const youboraIntegrationLevel = {
  disabled: 0,
  vod: 1,
  live: 2,
  both: 3
};

/**
 * Player states
 */
export const playerStates = {
  starting: 'starting',
  loading: 'loading',
  playing: 'playing',
  paused: 'paused',
  buffering: 'buffering',
  seeking: 'seeking',
  idle: 'idle',
  miniguide: 'miniguide'
};

/**
 * BI events
 */
export const eventsBI = {
  play: 'PLAY',
  resume: 'RESUME',
  stop: 'STOP',
  buffering: 'BUFFERING',
  audio: 'AUDIO',
  subtitle: 'SUBTITLE',
  error: 'ERROR'
};

export const defaultThreshold = 60;
export const defaultInterval = 60;
export const defaultWindow = 2 * defaultThreshold + 5;

/**
 * Inactivity timeouts
 */
export const inactivity = {
  close: 60 * 5,
  paused: 60 * 20,
  loading: 60 * 5,
  buffering: 60,
  goToLive: 10,
  parentalPin: 3 * 60
};

/**
 * Environment
 */
export const environment = {
  dev: 'dev',
  prod: 'prod'
};

export const marks = {
  realJoinTime: 'realJoinTime',
  joinTime: 'joinTime'
};

/**
 * Uniapi ConsumerKey and ConsumerSecret. These values are cyphered by the builder.
 */
export const ua = {
  query: process.env.CONSUMER_KEY,
  param: process.env.CONSUMER_SECRET
};

/**
 * Custom errors sent to youbora.
 */
export const youboraCustomErrors = {
  heartbeat: {
    code: 99001,
    description: 'HEARTBEAT_FAILED'
  }
};
